// ฟังก์ชันสำหรับลบรูปภาพโดยตรงจากฐานข้อมูล
// ใช้สำหรับการลบรูปภาพที่เริ่มพัฒนาหรือไม่ต้องการ

import { doc, getDoc, updateDoc, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * ลบรูปภาพแรกของน้องโดยตรงจากฐานข้อมูล
 * @param {string} girlId - ID ของน้อง
 * @returns {Promise<boolean>}
 */
export const deleteFirstImageFromDB = async (girlId) => {
  try {
    console.log(`🧹 เริ่มลบรูปภาพแรกของน้อง ${girlId} จากฐานข้อมูล`);
    
    // ดึงข้อมูลน้องจาก Firestore
    const girlRef = doc(db, 'girls', girlId);
    const girlSnap = await getDoc(girlRef);
    
    if (!girlSnap.exists()) {
      console.log(`❌ ไม่พบข้อมูลน้อง ${girlId}`);
      return false;
    }
    
    const girlData = girlSnap.data();
    
    // หารูปภาพแรก (จาก images array)
    if (girlData.images && girlData.images.length > 0) {
      const firstImage = girlData.images[0];
      console.log(`📷 พบรูปภาพแรก:`, firstImage);
      
      // ลบข้อมูลรูปภาพจาก Firestore
      await updateDoc(girlRef, {
        images: arrayRemove(firstImage),
        lastUpdated: new Date().toISOString()
      });
      
      console.log(`✅ ลบรูปภาพแรกของน้อง ${girlId} จากฐานข้อมูลสำเร็จ`);
      return true;
    } else {
      console.log(`❌ ไม่พบรูปภาพแรกของน้อง ${girlId}`);
      return false;
    }
    
  } catch (error) {
    console.error(`❌ เกิดข้อผิดพลาดในการลบรูปภาพแรกของน้อง ${girlId}:`, error);
    return false;
  }
};

/**
 * ลบรูปภาพทั้งหมดของน้องโดยตรงจากฐานข้อมูล
 * @param {string} girlId - ID ของน้อง
 * @returns {Promise<boolean>}
 */
export const deleteAllImagesFromDB = async (girlId) => {
  try {
    console.log(`🧹 เริ่มลบรูปภาพทั้งหมดของน้อง ${girlId} จากฐานข้อมูล`);
    
    // ดึงข้อมูลน้องจาก Firestore
    const girlRef = doc(db, 'girls', girlId);
    const girlSnap = await getDoc(girlRef);
    
    if (!girlSnap.exists()) {
      console.log(`❌ ไม่พบข้อมูลน้อง ${girlId}`);
      return false;
    }
    
    const girlData = girlSnap.data();
    const allImages = [
      ...(girlData.images || []),
      ...(girlData.pendingImages || []),
      ...(girlData.rejectedImages || [])
    ];
    
    console.log(`📊 พบรูปภาพทั้งหมด ${allImages.length} รูป`);
    
    // ลบข้อมูลรูปภาพทั้งหมดจาก Firestore
    await updateDoc(girlRef, {
      images: [],
      pendingImages: [],
      rejectedImages: [],
      lastUpdated: new Date().toISOString()
    });
    
    console.log(`✅ ลบรูปภาพทั้งหมดของน้อง ${girlId} จากฐานข้อมูลสำเร็จ`);
    return true;
    
  } catch (error) {
    console.error(`❌ เกิดข้อผิดพลาดในการลบรูปภาพทั้งหมดของน้อง ${girlId}:`, error);
    return false;
  }
};









